// Feather icons: <i data-feather="calendar"> is replaced with the SVG.
import feather from "feather-icons"

const replaceIcons = () => {
  try {
    feather.replace()
  } catch (e) {
    console.log("You might have made a typo with one of the feather icons", e)
  }
}

document.addEventListener("turbo:load", replaceIcons)
// A form answered with an error status (e.g. 422 on validation errors) is
// rendered without a visit, so only turbo:render fires, not turbo:load.
document.addEventListener("turbo:render", replaceIcons)
// Content loaded into a Turbo Frame (edit modal)
document.addEventListener("turbo:frame-load", replaceIcons)
